// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2A45q","label":"LabeledBox_label__7GmbR"};